'use strict';

class Slider {

    constructor() {

        this.cases();
        this.industries();
        this.brandSlider();
        this.processSlider();
        this.productDetails();
        this.vacancySlider();

    }

    cases() {

        let cases = document.querySelectorAll('.ce-cases-slider');

        if (cases.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of cases) {

                let swiper = new Swiper(slider.querySelector('.swiper-container'), {
                    init: false,
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 24,
                    slidesPerView: 1,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 16
                        }
                    }
                });

                swiper.init();

            }

        }

    }

    industries() {

        let industries = document.querySelectorAll('.ce-industries');

        if (industries.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of industries) {

                let swiper = new Swiper(slider.querySelector('.swiper-container'), {
                    init: false,
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 24,
                    slidesPerView: 3,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 16,
                            slidesPerView: 1
                        }
                    }
                });

                swiper.on('init', function () {

                    //  TODO; Fix equal Height?

                });

                swiper.init();

            }

        }

    }

    brandSlider() {

        let industries = document.querySelectorAll('.ce-brand-slider');

        if (industries.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of industries) {

                let swiper = new Swiper(slider.querySelector('.swiper-container'), {
                    init: false,
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 8,
                    slidesPerView: 6,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 4
                        },
                        768: {
                            slidesPerView: 2
                        }
                    }
                });

                swiper.init();

            }

        }

    }

    processSlider() {

        let processes = document.querySelectorAll('.ce-process');

        if (processes.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of processes) {

                let swiper = new Swiper(slider.querySelector('.swiper-container'), {
                    init: false,
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 24,
                    slidesPerView: 3,
                    watchOverflow: true,
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                    },
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    breakpoints: {
                        1023: {
                            spaceBetween: 16,
                            slidesPerView: 1
                        }
                    }
                });

                swiper.init();

            }

        }

    }

    productDetails() {

        let singleProduct = document.querySelector('.product-details');

        if (singleProduct) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            let galleryTop = new Swiper(singleProduct.querySelector('.highlight-image .swiper-container'), {
                loop: true,
                loopAdditionalSlides: 4,
                simulateTouch: false,
            });

            let galleryThumbs = new Swiper(singleProduct.querySelector('.thumbs .swiper-container'), {
                navigation: {
                    nextEl: singleProduct.querySelector('.thumbs .next-slide'),
                    prevEl: singleProduct.querySelector('.thumbs .prev-slide')
                },
                pagination: {
                    el: singleProduct.querySelector('.thumbs .swiper-pagination'),
                },
                loop: true,
                slidesPerView: 3,
                touchRatio: 0.2,
                slideToClickedSlide: true,
                centeredSlides: true,
            });

            galleryTop.controller.control = galleryThumbs;
            galleryThumbs.controller.control = galleryTop;

        }

    }

    vacancySlider() {

        let industries = document.querySelectorAll('.acf-vacancy-slider');

        if (industries.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of industries) {

                let swiper = new Swiper(slider.querySelector('.swiper-container'), {
                    init: false,
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 24,
                    slidesPerView: 1,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true
                    },
                });

                swiper.init();

            }

        }

    }

}

module.exports = Slider;
